import { render, staticRenderFns } from "./Tournament.vue?vue&type=template&id=50e71126"
import script from "./Tournament.js?vue&type=script&lang=js&external"
export * from "./Tournament.js?vue&type=script&lang=js&external"
import style0 from "./Tournament.vue?vue&type=style&index=0&id=50e71126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports